module.exports = __webpack_public_path__ + "static/media/user.6b856444.jpg";